import { Expose } from "../../serialization/class-transformer/decorators";

export class UIFinderJS {
    @Expose()
    url: string;
}
